import React, { useEffect } from 'react';
import { ReactComponent as ArrowIcon } from '../../assets/icons/downArrow.svg';

export const useDismissibleDropdown = (isOpen, dropdownRef, onDismiss) => {
  useEffect(() => {
    if (!isOpen) return;

    const handleClickAway = (event) => {
      if (!dropdownRef.current) return;
      if (!dropdownRef.current.contains(event.target)) {
        onDismiss();
      }
    };

    document.addEventListener('mousedown', handleClickAway, true);
    document.addEventListener('touchstart', handleClickAway, true);

    return () => {
      document.removeEventListener('mousedown', handleClickAway, true);
      document.removeEventListener('touchstart', handleClickAway, true);
    };
  }, [dropdownRef, isOpen, onDismiss]);
};

export const DashboardDropdownOption = ({ children, leading = null, onClick }) => (
  <button
    type="button"
    className="filter-option unselected-box"
    onClick={(event) => {
      event.stopPropagation();
      onClick?.();
    }}
  >
    {leading ? (
      <span className="filter-option__leading">
        {leading}
      </span>
    ) : null}
    <span className="filter-option__text">
      {children}
    </span>
  </button>
);

const DashboardDropdown = ({ title, value, isOpen, onToggle, dropdownRef, children }) => (
  <div className={`filter-row ${isOpen ? 'is-open' : ''}`.trim()}>
    <span className="filter-row__label label-muted">
      {title}
    </span>
    <div className="filter-dropdown" ref={dropdownRef}>
      <button
        type="button"
        className="filter-dropdown__trigger"
        aria-expanded={isOpen}
        onClick={onToggle}
      >
        <span className="filter-dropdown__value">
          {value}
        </span>
        <ArrowIcon className={`icon s filter-dropdown__caret${isOpen ? ' is-open' : ''}`} />
      </button>

      {isOpen ? (
        <div className="filter-dropdown__list">
          {children}
        </div>
      ) : null}
    </div>
  </div>
);

export default DashboardDropdown;
